import { ts } from '_core';


export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_DISTRIBUTION_OVER_TIME,
    title: 'Distribution Over Time',
    helpLabel: 'uc51wydx',
    form: false,
    neededFiles: ['signal_distribution_analysis'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL,
    ],
  },
] satisfies ts.types.analysis.WidgetConfig[];
